import { render, staticRenderFns } from "./EditUsernameModal.vue?vue&type=template&id=49b7953a&"
import script from "./EditUsernameModal.vue?vue&type=script&lang=js&"
export * from "./EditUsernameModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports